import { every } from 'lodash';

function CheckboxToggler(gettext, gettextCatalog) {
  'ngInject';

  return { isAllChecked, getToggleLabel };

  /**
   * @param {Array} list - list to search in
   * @param {String} key - key to search for criteria
   * @return {Boolean}
   */
  function isAllChecked(list, key) {

    if (!list || list.length === 0) {
      return false;
    }

    return every(list, {
      [key]: true
    });

  }

  /**
   * Return toggle label depending on toggled and filtered state
   *
   * @return {String}
   */
  function getToggleLabel(isChecked, isFiltered) {

    let label;

    if (!isChecked && !isFiltered) {
      label = gettext('action.enable.all');
    } else if (!isChecked && isFiltered) {
      label = gettext('action.enable.filtered');
    } else if (isChecked && !isFiltered) {
      label = gettext('action.disable.all');
    } else if (isChecked && isFiltered) {
      label = gettext('action.disable.filtered');
    }

    return gettextCatalog.getString(label);

  }
}


export { CheckboxToggler };
